import {yupResolver} from '@hookform/resolvers/yup';
import {
  Button,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from 'alm-react-components';
import { useContext, useEffect } from 'react';
import {useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import * as yup from 'yup';
import { AppContext } from '../../context/AppProvider';
type Inputs = {
  username: string;
};

type ResetPasswordFormProps = {
  username: string;
  error?: string;
  onSubmitUsername: (username: string) => void
};

const ResetPasswordForm = (Props: ResetPasswordFormProps) => {
  const {t} = useTranslation();
  const { state } = useContext(AppContext);

  async function onhandleSubmit(values: Inputs) {
    Props.onSubmitUsername(values.username)
  }
  const schema = yup
    .object({
      username: yup
        .string()
        .required(t('Validations.emailRequired'))
        .matches(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          t('Validations.validEmail')
        ),
    })
    .required();

  const form = useForm<Inputs>({
    resolver: yupResolver(schema),
    mode: 'onChange',
    defaultValues: {
      username: '',
    },
  });

  useEffect(()=>{
    if(state.user?.email && !form.formState.submitCount) {  
      form.setValue("username",state.user?.email);
      form.trigger('username')
    }
  },[form.formState.submitCount])

  return (
    <>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onhandleSubmit)} className="">
          <div className="grid w-full items-center gap-4 mb-6">
            <div className="flex flex-col space-y-1.5 text-base">
              <FormField
                control={form.control}
                name="username"
                render={({field}) => (
                  <FormItem>
                    <FormLabel className="font-opensansSemiBold text-xs tracking-wider">
                    <span dangerouslySetInnerHTML={{ __html: t('SignUp.email') }} />
                    </FormLabel>
                    <FormControl>
                      <Input
                        placeholder={t('PlaceHolder.enterEmailAddress')}
                        {...field}
                        className="h-auto py-4 text-base pe-16 opacity-100"
                      />
                    </FormControl>
                    <FormMessage>{Props.error}</FormMessage>
                  </FormItem>
                )}
              />
            </div>
          </div>
          <Button disabled={!form.formState.isValid} className="w-full h-auto py-2 px-0 text-base font-opensansSemiBold mt-6 mb-4">
            <span dangerouslySetInnerHTML={{ __html: t('SignUp.sendResetCode') }} />
          </Button>
        </form>
      </Form>
    </>
  );
};

export default ResetPasswordForm;
